export default function makeSrcSet(imageDPRx1, imageDPRx2, imageDPRx3) {
  const dpr1 = imageDPRx1 ? `${imageDPRx1} 1x,` : '';
  const dpr2 = imageDPRx2 ? `${imageDPRx2} 2x,` : '';
  const dpr3 = imageDPRx3 ? `${imageDPRx3} 3x,` : '';
  const srcSet = `${dpr1}${dpr2}${dpr3}`.slice(0, -1);

  return srcSet;
}
